const steps = [
  {
    icon: 'ri-cursor-line',
    title: '选择你的平台',
    desc: '根据设备选择 Android、iOS、HarmonyOS 或 TV 版卡片。',
  },
  {
    icon: 'ri-download-2-line',
    title: '获取安装包',
    desc: '点击「立即下载」，在新页面中获取对应版本的安装包。',
  },
  {
    icon: 'ri-play-circle-line',
    title: '安装并打开',
    desc: '完成安装后打开瓜子影视，登录账号即可开始观影。',
  },
];

const abilities = [
  { icon: 'ri-movie-2-line', label: '100万+ 影视资源' },
  { icon: 'ri-hd-line', label: '1080P / 4K 高清' },
  { icon: 'ri-cloud-line', label: '多端进度同步' },
  { icon: 'ri-download-cloud-2-line', label: '离线缓存观看' },
  { icon: 'ri-speed-up-line', label: '秒开秒播不卡顿' },
  { icon: 'ri-shield-check-line', label: '官方正版安装包' },
];

export default function GuaziInstallSteps() {
  return (
    <section className="w-full bg-background-100 px-4 md:px-6 py-16 md:py-24">
      <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
        <span className="inline-flex items-center gap-2 px-3 py-1.5 bg-primary-100 text-primary-700 rounded-full text-xs md:text-sm font-bold">
          <i className="ri-guide-line text-base" />
          安装教程
        </span>
        <h2 className="mt-4 font-heading font-extrabold text-3xl md:text-4xl text-foreground-950">
          三步完成瓜子影视安装
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mb-14 md:mb-20">
        {steps.map((step, index) => (
          <div key={step.title} className="relative bg-background-50 border border-background-200 rounded-lg p-6">
            <span className="absolute -top-4 left-6 w-9 h-9 flex items-center justify-center rounded-full bg-accent-500 text-accent-50 font-heading font-extrabold text-lg">
              {index + 1}
            </span>
            <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700">
              <i className={`${step.icon} text-2xl`} />
            </span>
            <h3 className="mt-4 font-heading font-bold text-lg md:text-xl text-foreground-950">{step.title}</h3>
            <p className="mt-2 text-sm text-foreground-600 leading-6">{step.desc}</p>
          </div>
        ))}
      </div>

      <div className="max-w-4xl mx-auto">
        <h3 className="text-center font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-8">
          下载后你将获得
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {abilities.map((item, index) => (
            <div
              key={item.label}
              className="flex items-center gap-3 px-4 py-4 bg-background-50 border border-background-200 rounded-lg"
            >
              <span className={`w-10 h-10 flex items-center justify-center rounded-lg shrink-0 ${index % 3 === 0 ? 'bg-primary-100 text-primary-700' : index % 3 === 1 ? 'bg-accent-100 text-accent-700' : 'bg-secondary-100 text-secondary-700'}`}>
                <i className={`${item.icon} text-xl`} />
              </span>
              <span className="text-sm md:text-base text-foreground-800 font-medium">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}